var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"investment-estimate-software"},[_c('h2',[_vm._v("开发中")]),_vm._v(" "),_c('p',[_vm._v("敬请期待")])])
}]

export { render, staticRenderFns }